import {defineStore} from "pinia";
import {ErrorLocationType, PopupType} from "@/utilities/system/enums/Enums";
import NullOrUndefinedHelper from "@/utilities/system/helpers/NullOrUndefinedHelper";
import {useSystemStore} from "@/stores/system/SystemStore";
import {ProviderService} from "@/utilities/services/entities/ProviderService";
import {$t} from "@/utilities/system/i18n/config";
import {Provider} from "@/models/entities/providers/Provider";

// this store exists because we have a backToEdit button in 'SimilarCompanies'-Popup and add or update action is not shared...
export const useProviderStore = defineStore('ProviderStore', {
    state:()=>{
        return {
            companyService: new ProviderService()
        }
    },
    actions: {
        async addOrUpdateProvider() {
            const systemStore = useSystemStore();

            // @ts-expect-error
            const company = systemStore.modal.contentObject.selectedProviderCompany === undefined
                ? systemStore.modal.contentObject
                // @ts-expect-error
                : systemStore.modal.contentObject.selectedProviderCompany ;

            // check if there are similar companies and offer them for selection
            if(company.id === ""){
                const similarCompaniesResp = await this.companyService.postGetAllSimilarProviders(company, ErrorLocationType.none);
                // if call fails silently fail... sad but true (\m/,) for the moment
                if(!similarCompaniesResp) return;

                if(similarCompaniesResp.companiesInfo.some(()=>true)){
                    // @ts-expect-error
                    similarCompaniesResp.companiesInfo = similarCompaniesResp.companiesInfo.map(sc => { sc["id"] = sc.companyId; return sc; });

                    company.id = "null";
                    systemStore.openPopup({
                        data: {"suggestedProviderCompany":company, "similarCompanies":similarCompaniesResp.companiesInfo, "selectedProviderCompany":company},
                        action: this.letEnterCompanyIdCodeIfNeeded,
                        resetButton: false,
                        title:$t("providerManagement.popups.similarCompanies"),
                        type:PopupType.selectSimilarProvider
                    });
                    return;
                }
            }

            await this.tryCreateAndConnectCompany(company);
        },

        async letEnterCompanyIdCodeIfNeeded(){
            const systemStore = useSystemStore();

            // @ts-expect-error
            const company = systemStore.modal.contentObject.selectedProviderCompany as CompanyInfo;

            // let enter CompanyIdCode if needed
            if(!NullOrUndefinedHelper(company.id) && (company.companyIdCode === undefined || company.companyIdCode === "")){
                systemStore.openPopup({
                    data: company,
                    action: this.addOrUpdateProvider,
                    resetButton: false,
                    title:$t("providerManagement.new"),
                    type:PopupType.providerManagementEditPopup
                });

                return;
            }

            await this.addOrUpdateProvider();
        },

        async tryCreateAndConnectCompany(company:Provider) {
            const systemStore = useSystemStore();

            const companyCreateResp = await this.companyService.addOrUpdateProvider(company, ErrorLocationType.popup);
            if (!companyCreateResp) return;

            // if creating new companies:
            // CAUTION: sadly there are 2 cases here: 1) similar companies found && still create -> id === "null" 2) no similar companyies found -> id === ""
            if(NullOrUndefinedHelper(company.id)){
                company.id = companyCreateResp.companyId;
                // @ts-expect-error
                company.companyId = company.id;
            }

            // connect companyEntity with current system (cross table entry AnAbSystemCompany)
            const connectResp = await this.companyService.postConnectSystemToProvider(undefined, company.id, company.companyIdCode, company.info, ErrorLocationType.popup);
            if (!connectResp){
                await this.companyService.deleteSystemConnectionToProvider(company.id, ErrorLocationType.popup); // fire and forget call

                company.id = "null";
                // @ts-expect-error
                delete company.companyId;

                return;
            }

            // @ts-expect-error
            company.address = `${company.street} ${company.streetnumber}, ${company.zip} ${company.city}`;

            systemStore.gridStore?.add(company);
            systemStore.gridStore?.sort(systemStore.gridStore.sorters);

            systemStore.closeModal();
            systemStore.showSuccess($t('global.saved'));
        }
    }

})